import moment from 'moment-timezone';

export const formatToLocalTime = (
  utcDate,
  format = "MMMM Do YYYY hh:mm A",
  fallbackTimezone = "America/Denver"
) => {
  if (!utcDate) return '';

  // Auto-detect user's time zone
  let detectedZone = moment.tz.guess();


  // Verify the detected zone is valid (should always be with moment)
  const isValidZone = moment.tz.zone(detectedZone) !== null;

  // Use detected if valid, otherwise use fallback
  const finalTimezone = isValidZone ? detectedZone : fallbackTimezone;


  return moment.utc(utcDate).tz(finalTimezone).format(format);
};

export const getDateTimeInfo = (fallbackTimezone = "America/Denver") => {
  const timezone =fallbackTimezone;
  const now = moment().tz(timezone);

  return {
    iso: now.toISOString(), // UTC format
    formatted: now.format("MMMM Do YYYY hh:mm A"),
    timezone,
    offset: now.format("Z"),           // e.g., -06:00
    abbreviation: now.format("z"),     // e.g., MDT or MST
    unix: now.unix(),                  // epoch seconds
    epochMillis: now.valueOf()         // epoch milliseconds
  };
};